import axios from 'axios'
import Vue from 'vue'
import AppUser from '../classes/appUser'

export default {
  namespaced: true,

  state: {
    user: null,
    token: sessionStorage.getItem('token') || null,
    userLoaded: false
  },

  mutations: {
    token_set(state, token) {
      if (token != null) {
        state.token = token
      }
    },
    token_store(state, token) {
      if (token != null) {
        sessionStorage.setItem('token', token)
        state.token = token
      }
    },
    token_reset(state) {
      state.token = null
      sessionStorage.removeItem('token')
    },
    user_set(state, user) {
      state.user = user
      state.userLoaded = true
      Vue.prototype.$currentUser = new AppUser(user)
    },
    user_reset(state) {
      state.user = null
      state.userLoaded = false
      localStorage.removeItem('login');
      localStorage.removeItem('password');
      Vue.prototype.$currentUser = null
    }
  },

  // ========== ДОБАВЛЯЕМ GETTERS ==========
  getters: {
    // Получить ID пользователя из токена
    userId: (state) => {
      const token = state.token || sessionStorage.getItem('token') || localStorage.getItem('token');
      if (!token) return 0;

      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64).split('').map(c =>
            '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          ).join('')
        );
        const tokenData = JSON.parse(jsonPayload);
        return parseInt(tokenData.UserID || 0);
      } catch (e) {
        console.error('Ошибка декодирования токена:', e);
        return 0;
      }
    },

    // Проверка доступа к резервам
    hasReserveAccess: (state, getters) => {
      const userId = getters.userId;
      return [10, 20, 23, 45].includes(userId);
    },

    // Проверка доступа к инцидентам
    hasIncidentAccess: (state, getters) => {
      const userId = getters.userId;
      return [10, 20, 23, 45].includes(userId);
    },

    // Проверка авторизации
    isAuthenticated: (state) => !!state.token,

    // Получить пользователя
    getUser: (state) => state.user,

    // Получить токен
    getToken: (state) => state.token
  },

  actions: {
    setToken({ commit }, token) {
      commit('token_set', token)
      commit('token_store', token)
    },

    restoreToken({ commit }) {
      const token = sessionStorage.getItem('token')
      commit('token_set', token)
    },

    async validateAuthToken({ commit }, { userId, authCode }) {
      try {
        const response = await axios.post('/auth/ValidateAuthToken', {
          userId: parseInt(userId),
          authCode: authCode.trim()
        });

        const data = response.data;

        if (data.token) {
          commit('token_set', data.token);
          sessionStorage.setItem('token', data.token);
        }

        return data;

      } catch (error) {
        console.error('Validate auth token error:', error);
        throw error;
      }
    },

    async login({ commit }, { login, password }) {
      try {
        const response = await axios.post('/auth/login', { login, password });
        const data = response.data;

        if (data.token) {
          commit('token_set', data.token);
          sessionStorage.setItem('token', data.token);
        }

        return data;

      } catch (error) {
        console.error('Authentication error:', error);
        throw error;
      }
    },

    async setUser({ dispatch, commit }) {
      await dispatch('cargoTypes/init', null, { root: true })
      await dispatch('settings/init', null, { root: true })

      const response = await axios.get('/auth/CurrentUser')

      // Логируем для отладки
      console.log('📥 Данные пользователя:', response.data);

      commit('user_set', response.data)
    },

    logout({ dispatch, commit }) {
      dispatch('cargoTypes/reset', null, { root: true })
      dispatch('settings/reset', null, { root: true })

      commit('token_reset')
      commit('user_reset')
    },

    async restoreSession({ dispatch, commit, state }) {
      const token = state.token || sessionStorage.getItem('token')
      if (!token) return false

      commit('token_set', token) // на случай, если токен только в sessionStorage

      try {
        await dispatch('setUser')
        return true
      } catch (e) {
        // токен просрочен/невалиден — чистим
        commit('token_reset')
        commit('user_reset')
        return false
      }
    }
  }
}